import { Form } from 'react-bootstrap';
import { Select } from '../Select';
import { I18n } from '@/i18n/I18n';
import { ParameterInputType, ParameterType } from '@/types/parameterTypes';
import { useTreeStore } from '@/frontend/store/TreeStore';
import { useEffect } from 'react';

export function InputTypeSelect(props: {
  inputType: ParameterInputType,
  setInputType: (inputType: ParameterInputType) => void,
  disabled: boolean,
  parameterType?: ParameterType,
  typeOptions?: ParameterInputType[],
  subjectId?: string,
  allowChoice?: boolean,
}) {
  const { inputType, setInputType, disabled, parameterType, typeOptions, subjectId, allowChoice } = props;
  const containerLookup = useTreeStore(state => state.containerLookup);
  const isRepeatingStepOutput = subjectId && containerLookup[subjectId]?.container.isRepeatingStep() && parameterType === ParameterType.OUTPUT;

  useEffect(() =>{
   if (isRepeatingStepOutput && inputType === ParameterInputType.FREE_FORM) {
    setInputType(ParameterInputType.TABLE);
   }
  }, [isRepeatingStepOutput, inputType, setInputType]);

  let options = Object.values(ParameterInputType);

  if (!isRepeatingStepOutput) {
    options = options.filter(type => type !== ParameterInputType.TABLE);
  } else if (isRepeatingStepOutput) {
    options = options.filter(type => type !== ParameterInputType.FREE_FORM && type !== ParameterInputType.SINGLE_CHOICE && type !== ParameterInputType.MULTIPLE_CHOICE);
  }

  if (!allowChoice) {
    options = options.filter(type => type !== ParameterInputType.SINGLE_CHOICE && type !== ParameterInputType.MULTIPLE_CHOICE);
  }

  if (typeOptions) {
    options = typeOptions;
  }

  return (
    <>
      <Form.Label className='mt-3'>{I18n.get('inputType')}</Form.Label>
      <Select label={I18n.get('selectInputType')} value={I18n.get(inputType)} disabled={disabled}> {
        options.map((inputFieldType) => (
          <button type="button" key={inputFieldType} className="w-100 dropdown-item" onClick={() => setInputType(inputFieldType)}>
            {I18n.get(inputFieldType)}
          </button>
        ))
      }
      </Select>
    </>
  );
}
